var React = require('react');

function IcoShare (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17,34C7.6,34,0,26.4,0,17S7.6,0,17,0s17,7.6,17,17S26.4,34,17,34z M17,1C8.2,1,1,8.2,1,17s7.2,16,16,16s16-7.2,16-16\n      S25.8,1,17,1z","key":0}),React.createElement("path",{"d":"M10.2,23.4c-0.4,0-0.7-0.3-0.7-0.7c0.5-7.4,5.2-8.6,6.8-8.8v-2.1c0-0.5,0.3-0.8,0.7-0.9c0.4-0.1,0.8,0,1,0.2\n      c0.7,0.6,1.7,1.6,2.6,2.5c1,1,2,2,2.5,2.4c0.2,0.2,0.4,0.4,0.4,0.7c0,0.3-0.2,0.6-0.3,0.8c-1,1-3.8,3.7-5.2,5\n      c-0.2,0.2-0.7,0.4-1.1,0.2c-0.1-0.1-0.6-0.3-0.6-0.8V20c-2.1,0.2-4.3,1.4-5.4,3l-0.1,0.1C10.6,23.4,10.3,23.4,10.2,23.4z M16.8,14.9\n      c-0.2,0-5.4,0.1-6.2,7c1.4-1.7,3.9-2.9,6.2-2.9h0.5v2.8c1.4-1.3,4.1-3.9,5.1-4.9c-0.5-0.5-1.5-1.4-2.5-2.4c-0.9-0.9-1.9-1.9-2.6-2.5\n      v3H16.8z M22.5,17L22.5,17L22.5,17z","key":1})]);
}

IcoShare.defaultProps = {"viewBox":"0 0 35 35","id":"shareblack","width":"35px","height":"35px"};

module.exports = IcoShare;

IcoShare.default = IcoShare;
